export const userProfileColumns = [
    { Header: 'User Name', id: 'userName' },
    { Header: 'Email Address', id: 'email' }
];

export const userRoleColumns = [
    { Header: 'Roles', id: 'role' }
];

export const appConfigColumns = [
    { Header: 'Setting', id: 'label' },
    { Header: 'Value', id: 'value' }
];
